export const PAGE_HEADER_MIN_HEIGHT = {
    desktop: 84,
    mobile: 58,
};
